type TitleEntry = {
  id: string;
  title?: string;
};

export class TitleManager {
  private stack: TitleEntry[] = [];

  private defaultTitle: string;

  constructor(defaultTitle: string) {
    this.defaultTitle = defaultTitle;
  }

  push(id: string, title?: string): void {
    this.stack.push({ id, title });
    this.applyTitle();
  }

  update(id: string, title?: string): void {
    const item = this.stack.find((el) => el.id === id);
    if (item) {
      item.title = title;
      this.applyTitle();
    }
  }

  remove(id: string): void {
    this.stack = this.stack.filter((el) => el.id !== id);
    this.applyTitle();
  }

  private applyTitle(): void {
    if (typeof document === "undefined") return;

    const lastWithTitle = [...this.stack]
      .reverse()
      .find((el) => el.title && el.title.trim().length > 0);

    const finalTitle = lastWithTitle
      ? `${lastWithTitle.title} | ${this.defaultTitle}`
      : this.defaultTitle;

    document.title = finalTitle;

    window.history.replaceState(
      window.history.state,
      finalTitle,
      window.location.href,
    );
  }
}

export const titleManager = new TitleManager(
  window.initialWsData?.pageTitle ?? "Creator SaaS",
);
